import React, { useState, useEffect, useRef } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { EMAIL_VALIDATOR } from "helpers/validators.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";

const RecipientEmailSettings = ({
  invalidEmailReceiveFiles,
  setInvalidEmailReceiveFiles,
  invalidAlert,
  setEmailToReceiveFiles,
  emailToReceiveFiles,
  setUpdateBeforeSave,
}) => {
  const recipientsRef = useRef();
  const { isPremium, getUserData, isBusiness } = useUser();
  const { setModal } = useModal();
  const { getTextByKey } = useContent();
  const [listRecipients, setListRecipients] = useState([]);
  const [tempRecipient, setTempRecipient] = useState(
    isPremium() || isBusiness() ? emailToReceiveFiles : getUserData().UserName
  );
  const [updateRecipientList, setUpdateRecipientList] = useState(false);
  const [singleRecipient, setSingleRecipient] = useState("");

  useEffect(() => {
    if (invalidAlert) {
      // addToast(getTextByKey(invalidAlert), {
      //   appearance: "error",
      // });
    }
  }, [invalidAlert]);

  useEffect(() => {
    if (tempRecipient) {
      if (tempRecipient.includes(",")) {
        setListRecipients(tempRecipient.split(","));
      } else {
        setListRecipients([tempRecipient]);
      }
    } else {
      setListRecipients([]);
    }
  }, [tempRecipient]);

  const handleChangeRecipients = (e) => {
    if (isPremium() || isBusiness()) {
      setSingleRecipient(e);
      setInvalidEmailReceiveFiles(false);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  useEffect(() => {
    if (updateRecipientList) {
      setSingleRecipient("");
      let tempRecipientField = "";
      if (emailToReceiveFiles) {
        if (singleRecipient) {
          tempRecipientField = `${singleRecipient},${emailToReceiveFiles}`;
        } else {
          tempRecipientField = emailToReceiveFiles;
        }
      } else {
        tempRecipientField = singleRecipient;
      }
      setEmailToReceiveFiles(tempRecipientField);
      setTempRecipient(tempRecipientField);
      setUpdateRecipientList(false);
      setUpdateBeforeSave({ mode: true, action: "updateRecipientList" });
    }
  }, [updateRecipientList]);

  useOnClickOutside(recipientsRef, () => {
    updateList();
  });

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      updateList();
    }
  };

  const handleRemoveRecipient = (recipient) => {
    if (isPremium() || isBusiness()) {
      let newList = listRecipients.filter((item) => item !== recipient);
      if (newList) {
        if (newList.length > 1) {
          setTempRecipient(newList.join(","));
          setEmailToReceiveFiles(newList.join(","));
        } else {
          setTempRecipient(newList[0]);
          setEmailToReceiveFiles(newList[0]);
        }
      } else {
        setTempRecipient("");
        setEmailToReceiveFiles("");
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const updateList = () => {
    const validReceiveEmail = new RegExp(EMAIL_VALIDATOR);
    if (singleRecipient) {
      if (singleRecipient.includes(",")) {
        let arr = singleRecipient.split(",");
        for (let i = 0; i < arr.length; i++) {
          const element = arr[i].trim();
          if (validReceiveEmail.test(element)) {
            setUpdateRecipientList(true);
            setInvalidEmailReceiveFiles(false);
          } else {
            setInvalidEmailReceiveFiles(true);
            break;
          }
        }
      } else {
        if (validReceiveEmail.test(singleRecipient)) {
          setInvalidEmailReceiveFiles(false);
          setUpdateRecipientList(true);
        } else {
          setInvalidEmailReceiveFiles(true);
        }
      }
    }
  };

  return (
    <div
      className={`receive-email ${
        invalidEmailReceiveFiles ? "invalid-email" : ""
      }`}
    >
      <div className="recipients-div">
        {listRecipients &&
          listRecipients.map((item, i) => (
            <div key={i} className="item-recipient">
              <span>{item}</span>
              <span
                onClick={() => handleRemoveRecipient(item)}
                className="x-icon"
              >
                <Icon name="x" />
              </span>
            </div>
          ))}
      </div>
      <div className="div-input">
        <input
          ref={recipientsRef}
          type="email"
          onChange={(e) => handleChangeRecipients(e.target.value)}
          onKeyDown={(e) => handleEnterKey(e)}
          value={singleRecipient}
        />
      </div>
      {invalidEmailReceiveFiles ? (
        <>
          <span className="invalid-email-text span-text">
            {getTextByKey("invalid-email-address")}
          </span>
          <br></br>
        </>
      ) : null}
      <div className="small-text">
        <span className="span-text">
          {getTextByKey("email-receive-files-text")}
        </span>
      </div>
    </div>
  );
};

export default RecipientEmailSettings;
